import { render, staticRenderFns } from "./OpenChecks.vue?vue&type=template&id=245d70f8"
import script from "./OpenChecks.vue?vue&type=script&lang=js"
export * from "./OpenChecks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports